import withModal from '../../../../../components/global/modal/withModal';
import PhotoForFacesHighlightContainer from './PhotoForFacesHighlightContainer';

export const PHOTO_FOR_FACES_HIGHLIGHT_MODAL =
  'PHOTO_FOR_FACES_HIGHLIGHT_MODAL';

const PhotoForFacesHighlightModal = withModal(PhotoForFacesHighlightContainer, {
  name: PHOTO_FOR_FACES_HIGHLIGHT_MODAL,
  type: 'full',
  className: 'photo-overlay-viewer',
  overlayClassName: 'z-modal-max',
  hideHeader: true,
});

export default PhotoForFacesHighlightModal;
